module.exports = __webpack_public_path__ + "img/leptinotarsa-decemlineata.8f6766b4.jpg";